import { forLoggedInUser } from '../channels';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const ASSIGNED = 'JOBS/ASSIGNED';

export const jobAssignedActionSchema = objectSchemaOf<IAssignedAction>({
  type: Joi.string().required().valid(ASSIGNED),
  payload: Joi.object({
    conversationId: Joi.string().required(),
    uid: Joi.string().required(),
  }).required(),
});

export interface IAssignedPayload {
  conversationId: string;
  uid: string;
}

export interface IAssignedAction {
  type: typeof ASSIGNED;
  payload: IAssignedPayload;
}

export const assigned = actionCreator({
  type: ASSIGNED,
  schema: jobAssignedActionSchema,
  channels: [forLoggedInUser],
});
